import church from './church-new.png';
import cloud1 from './crop-cloud-1.PNG';
import cloud2 from './crop-cloud-2.PNG';
import grass1 from './crop-grass-1.PNG';
import trees from './crop-trees-1.PNG';
import hills1 from './crop-hills-1-new.PNG';
import hills2 from './crop-hills-2.PNG';
import bush1 from './bush-4.png';
import bush2 from './bush-2.png';
import flowers from './flowers.png';
import grass2 from './grass-2.png';

export const coverArt = {
  church,
  cloud1,
  cloud2,
  grass: grass1,
  trees,
  hills1,
  hills2,
  bush1,
  bush2,
  flowers,
  grass2,
}; 
